import {useContext} from 'react'
import {UserContext} from 'context/UserContext'
import {mapRole} from '../../helpers/wording'

const SidebarHeader = () => {
  const [user] = useContext(UserContext)

  const userRole = mapRole(user.userInfo?.role ||'')

  return (
    <div className="sidebar__header">
      <img className="sidebar__brand__image" src="/media/logoSawitpro.png" alt="blah" />
      <div className="flex flex-col">
        <h2 className="sidebar__brand__title font-semibold text-lg mb-0 mt-0">SawitPRO</h2>
        <span className="font-semibold text-sm text-gray-700">{userRole}</span>
      </div>
    </div>
  )
}

export default SidebarHeader
